import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FrecuenciaSection } from './components/FrecuenciaSection';
import { CienciaSection } from './components/CienciaSection';
import { TestimoniosSection } from './components/TestimoniosSection';
import { IdentitySection } from './components/IdentitySection';
import { ProtocoloSection } from './components/ProtocoloSection';
import { Footer } from './components/Footer';
import { SalesNotification } from './components/SalesNotification';
export function App() {
  useEffect(() => {
    // Inject Meta Pixel via script tag - no external package needed
    try {
      if (typeof window !== 'undefined' && !(window as any).fbq) {
        const f = window as any;
        const n = f.fbq = function (...args: any[]) {
          if (n.callMethod) {
            n.callMethod.apply(n, args);
          } else {
            n.queue.push(args);
          }
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [] as any[];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
        ;
        (window as any).fbq('init', '919180517627113');
        (window as any).fbq('track', 'PageView');
        (window as any).fbq('track', 'ViewContent', {
          content_name: 'EL CÓDIGO 888 - Sistema de Programación Neuro-Cuántica',
          content_ids: ['51934295621934'],
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
    } catch (e) {
      console.warn('Facebook Pixel failed to load:', e);
    }
  }, []);
  const handlePurchase = () => {
    try {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          content_ids: ['51934295621934'],
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
    } catch (e) {
      console.warn('Facebook Pixel tracking failed:', e);
    }
    window.location.href = 'https://www.betterdailyguides.com/cart/51934295621934:1';
  };
  return <div className="min-h-screen bg-dark font-sans text-white selection:bg-gold/30 selection:text-gold overflow-x-hidden w-full" data-id="element-0">
      <Navbar handlePurchase={handlePurchase} data-id="element-1" />
      <main className="overflow-x-hidden" data-id="element-2">
        <HeroSection handlePurchase={handlePurchase} data-id="element-3" />
        <FrecuenciaSection data-id="element-4" />
        <CienciaSection data-id="element-5" />
        <TestimoniosSection data-id="element-6" />
        <IdentitySection handlePurchase={handlePurchase} data-id="element-7" />
        <ProtocoloSection handlePurchase={handlePurchase} data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <SalesNotification data-id="element-10" />
    </div>;
}